<template>
  <div class="sale-info">
    <table-list
      title="商品列表"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="dataList"
      :columns="columns(this)"
      :btns="btns(this)"
      :options="{ selection: true }"
      :pager="pager"
      :tabs-list="tabsList"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
const tabsList = [
  {
    prop: 'payStatus',
    activeValue: '',
    children: [
      { value: 'WAIT', label: '待支付' },
      { value: 'SUCCESS', label: '已完成' },
      { value: 'CLOSE', label: '已取消' },
      { value: 'REFUND', label: '已退款' },
    ],
  },
]

const btns = _this => [
  {
    label: '导出',
    method: _this.handleExport,
    type: 'primary',
  },
]

const searchForm = _this => [
  {
    label: '订单编号',
    prop: 'orderId',
    placeholder: '请输入订单编号',
  },
  {
    label: '购买用户手机',
    prop: 'phone',
    placeholder: '请输入购买用户手机',
  },
  {
    label: '支付渠道',
    placeholder: '请选择支付渠道',
    type: 'select',
    prop: 'payType',
    children: _this.payTypeList.map(item => ({
      label: item.typeCode,
      value: item.typeName,
    })),
  },
  {
    label: '实付金额',
    type: 'section',
    propLeft: 'beginAmount',
    propRight: 'endAmount',
  },
  {
    label: '创建时间',
    type: 'picker',
    prop: 'createTime',
    pickerDate: _this.pickerDate,
  },
]

const columns = () => [
  {
    prop: 'orderIdDetail',
    label: '订单编号',
    minWidth: 150,
  },
  {
    prop: 'payUserName',
    label: '购买用户',
    minWidth: 100,
  },
  {
    prop: 'phone',
    label: '用户手机号',
    minWidth: 120,
  },
  {
    prop: 'skuName',
    label: '规格',
    minWidth: 120,
    twoLines: true,
  },
  {
    prop: 'productSumAmount',
    label: '订单金额',
    minWidth: 100,
    align: 'right',
    sortdata: 1,
    formatter: row => {
      return `￥${row.productSumAmount}`
    },
  },
  {
    prop: 'amount',
    label: '实付金额',
    minWidth: 100,
    align: 'right',
    sortdata: 2,
    formatter: row => {
      return `￥${row.amount}`
    },
  },
  {
    prop: 'orderStatusName',
    label: '订单状态',
    minWidth: 80,
  },
  {
    prop: 'saleType',
    label: '销售渠道',
    minWidth: 80,
  },
  {
    prop: 'payTypeName',
    label: '支付渠道',
    minWidth: 80,
    formatter: row => {
      return row.payTypeName || '-'
    },
  },
  {
    prop: 'createTimeShow',
    label: '创建时间',
    minWidth: 150,
    sortdata: 3,
  },
  {
    prop: 'payTimeShow',
    label: '支付时间',
    minWidth: 150,
    sortdata: 4,
    formatter: row => {
      return row.payTimeShow || '-'
    },
  },
]

import TableList from '@/components/TableList'
import to from 'await-to'
import {
  deGreeOrderSaleList,
  deGreeOrderSalePayTypeFilter,
  deGreeOrderSaleListExport,
} from '@/api/center'
export default {
  name: 'SaleInfo',
  components: {
    TableList,
  },
  data() {
    return {
      pickerDate: {
        onPick: ({ minDate }) => {
          this.pickerMinDate = minDate.getTime()
        },
        disabledDate: time => {
          const year = 365 * 24 * 3600 * 1000
          let oneYearLater = this.pickerMinDate + year
          return time.getTime() > oneYearLater //注意是||不是&&
        },
      },
      btns,
      tabsList,
      searchForm,
      columns,
      loading: false,
      pager: {
        total: 400,
        size: 10,
        current: 1,
      },
      dataList: [],
      selectList: [],
      queryParams: {},
      productId: this.$route.query.productId,
      payTypeList: [],
    }
  },
  mounted() {
    this.handlePayTypeFilter()
    if (this.productId) this.getList()
  },
  methods: {
    async handlePayTypeFilter() {
      const [res, err] = await to(deGreeOrderSalePayTypeFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.payTypeList = res.data
    },
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        deGreeOrderSaleList({ current, size, ...this.queryParams, productId: this.productId }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.pager.total = res.data.total
      this.dataList = res.data.list
    },
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      if (queryParams.createTime && queryParams.createTime !== 0) {
        this.queryParams.beginCreateTime = queryParams.createTime[0]
        this.queryParams.endCreateTime = queryParams.createTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        this.queryParams.beginCreateTime = ''
        this.queryParams.endCreateTime = ''
      }
      this.getList()
    },
    async handleExport() {
      let ids = []
      this.selectList.map(v => ids.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        deGreeOrderSaleListExport({
          current,
          size,
          productId: parseInt(this.productId),
          ids: ids,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '商品销售列表.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>
